import { ThemeProvider } from "@emotion/react";
import { ChangeEvent, useEffect } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { responsibleFilterDelete, responsibleFilterSet } from "../../../store";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { plantingTheme } from "../../Register/RegisterList/PlantingTheme";
import { responsibleFilterAction } from "../../../store/responsibleFilter-slice";

type FormValues = {
  category: string;
  isActive: string;
};

const ResponsibleFilterBox = () => {
  const { t } = useTranslation();
  const { handleSubmit, control, reset, resetField } = useForm<FormValues>();
  const isFilterSet = useSelector(responsibleFilterSet);
  const deleteItem = useSelector(responsibleFilterDelete);

  const dispatch = useDispatch();

  useEffect(() => {
    if (deleteItem !== "") {
      resetField(deleteItem);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteItem]);

  const applyFilter = (data: FormValues) => {
    dispatch(
      responsibleFilterAction.setFilter({
        category: data.category,
        isActive: data.isActive,
      })
    );
    dispatch(responsibleFilterAction.setURL());
    dispatch(responsibleFilterAction.isFilterSet());
  };

  const clearFilter = () => {
    reset();
    dispatch(responsibleFilterAction.clearFilter());
    dispatch(responsibleFilterAction.setURL());
  };
  return (
    <ThemeProvider theme={plantingTheme}>
      <div className="w-full h-fit bg-white p-4 rounded-md relative mt-3">
        <form onSubmit={handleSubmit(applyFilter)} className="mt-4">
          <div className="flex flex-wrap justify-between w-full sm:w-[80%] md:w-[65%]">
            <div className="w-full lg:w-[48%]">
              <p className="text-sm text-default-text mb-[6px]">
                {t("Tree register responsible.Responsible category")}
              </p>

              <Controller
                control={control}
                name="category"
                render={({ field: { onChange, value } }) => (
                  <FormControl style={{ width: "100%" }}>
                    <InputLabel shrink={false}>
                      {!value &&
                        t("Tree register responsible.Responsible category")}
                    </InputLabel>
                    <Select
                      style={{ height: "38px" }}
                      IconComponent={ExpandMoreIcon}
                      variant="outlined"
                      value={value || null}
                      onChange={(e) => {
                        onChange(e as ChangeEvent<Element>);
                      }}
                      sx={{
                        border: "1px solid #eeecec",
                        borderRadius: "4px",
                        "& fieldset": { border: "none" },
                      }}
                    >
                      <MenuItem value="fun">FUNDAEC</MenuItem>
                      <MenuItem value="grp">{t("Register.Group")}</MenuItem>
                      <MenuItem value="ins">
                        {t("Register.Institution")}
                      </MenuItem>
                    </Select>
                  </FormControl>
                )}
              />
            </div>

            <div className="w-full lg:w-[48%]">
              <p className="text-sm mb-[6px]">
                {t("Workshops.Workshop status")}
              </p>

              <Controller
                control={control}
                name="isActive"
                render={({ field: { onChange, value } }) => (
                  <FormControl style={{ width: "100%" }}>
                    <InputLabel shrink={false}>
                      {!value && `${t("Workshops.Workshop status")}`}
                    </InputLabel>
                    <Select
                      style={{ height: "38px" }}
                      IconComponent={ExpandMoreIcon}
                      variant="outlined"
                      value={value || null}
                      onChange={(e) => {
                        onChange(e as ChangeEvent<Element>);
                      }}
                      sx={{
                        border: "1px solid #eeecec",
                        borderRadius: "4px",
                        "& fieldset": { border: "none" },
                      }}
                    >
                      <MenuItem value="true">{t("Department.Active")}</MenuItem>
                      <MenuItem value="false">
                        {t("Department.Inactive")}
                      </MenuItem>
                    </Select>
                  </FormControl>
                )}
              />
            </div>
          </div>
          <div className="mt-5 sm:mt-0 sm:absolute sm:right-4 sm:bottom-4">
            {isFilterSet && (
              <button
                className="py-2 px-6 text-sm font-medium rounded-3xl text-default-text hover:bg-ph-input mr-3"
                type="button"
                onClick={clearFilter}
              >
                {t("PlantingFilter.Reset")}
              </button>
            )}
            <button
              type="submit"
              className="white-btn border border-ph-btn text-sm font-medium py-2 px-6"
            >
              {t("PlantingFilter.Apply")}
            </button>
          </div>
        </form>
      </div>
    </ThemeProvider>
  );
};
export default ResponsibleFilterBox;
